import { makeStyles } from "@material-ui/core";
import styled from "styled-components";
import { theme as themeConfig } from "@themes";

export const ButtonWrapper = styled.div`
  /* position: fixed;
    right: 0px; */
  display: flex;
  flex-direction: row;
  width: ${({ surveyStateId }) => (surveyStateId === 5 ? `11.5em` : `16.5em`)};
  justify-content: flex-end;
  ${({ OnlyAssigned }) => OnlyAssigned && `z-index: 2;`}
`;

export const StyleButton = styled.button`
  border: 1px solid ${({ theme }) => theme.button.primaryBorder};
  color: ${({ theme }) => theme.button.primary};
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 80%;
  height: 40px;
  margin: 0 0.5em 0 0;
  font-size: 14px;
  font-weight: 600;
  font-family: ${({ theme }) => theme.secondaryFontFamilyTwo};
  opacity: ${({ isNotDisabled, OnlyAssigned }) =>
    !isNotDisabled ? "1" : "0.4"};
  &:hover {
    background: ${({ theme }) => theme.button.primaryHover};
    color: ${({ theme }) => theme.neutral.white};
  }
  /* background: ${({ theme }) => theme.primaryBackgroundLight};
  border: 1px solid ${({ theme }) => theme.primary.purple};
  box-sizing: border-box;
  border-radius: 3px;
  color: ${({ theme }) => theme.button.primary};
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  cursor: pointer; */

  /* grid-row: 6;
    align-self: center;
    justify-self: right;
    margin-right: 0.4rem;
    width: 7rem;
    height: 2rem;
    outline: 0;
    padding: 6px 12px;
    color: ${({ theme }) => theme.neutral.white};
    border-radius: 5px;
    border: none;
    background: ${({ theme }) => theme.button.primary};
    transition: transform 0.1s ease;

   */
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
export const ContentCloseButton = styled.div`
  background-color: ${({ theme }) => theme.button.primary};
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  width: 20%;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.neutral.white};
  
  /* Estilos específicos para CloseButton de react-bootstrap */
  .close,
  button.close,
  .btn-close {
    color: ${({ theme }) => theme.neutral.white} !important;
    opacity: 1 !important;
    text-shadow: none !important;
    filter: brightness(0) invert(1);
    
    &:hover,
    &:focus {
      color: ${({ theme }) => theme.neutral.white} !important;
      opacity: 0.8 !important;
    }
  }
  
  .text-light {
    color: ${({ theme }) => theme.neutral.white}; 
  }
  
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const ContentCommentIcon = styled.div`
  border: 1px solid rgb(46, 46, 46);
  justify-content: center;
  display: ${(props) =>
    (props.surveyStateId && props.surveyStateId === 7) ||
      (props.surveyStateId && props.surveyStateId === 6)
      ? "flex"
      : "none"};
  align-items: center;
  width: 4.5em;
  height: 40px;
  border-radius: 3px;
  margin-right: 1em;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;

export const useStyles = makeStyles(() => ({
  commentIconStyle: {
    color: themeConfig.button.primary,
  },
}));
